import config from 'config';
import {LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import {
    TextField,
    MenuItem,
    useTheme,
    Grid,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    Paper,
    TableCell,
    TableBody,
    Input,
    Box,
    IconButton,
    Tooltip
} from "@mui/material";
import {IconCurrencyShekel, IconEye, IconEyeOff} from "@tabler/icons";
import {DatePicker} from '@mui/lab';
import {format, parseJSON} from "date-fns";
import {he, enUS} from "date-fns/locale";
import JSDB from "fromKotlin/nk";
import React, {useCallback} from "react";
import {FormattedMessage} from "react-intl";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "store";
import {getSpecificCustomer, selectCustomerById} from "store/customers/customersSlice";
import {getSpecificSupplier, getSuppliers, selectSupplierById} from "store/suppliers/suppliersSlice";
import {displayDocumentId, isSupplierDocument} from "types/DocumentsTypes/Document";
import {BankAutocomplete} from "../receipt/BankAutocomplete";
import {paymentMethods, PaymentMethod} from "types/document";
import SubCard from "ui-component/cards/SubCard";
import Chip from "ui-component/extended/Chip";
import HoverableIncrementer from "ui-component/HoverableIncrementer";
import Logo from "ui-component/Logo";
import {NoNegativeInput} from "ui-component/textFieldNumber";
import DocumentClientDetails from "../document_header_preview/DocumentClientDetails";
import DocumentHeaderPreview from "../document_header_preview/DocumentHeaderPreview";
import {roundDecimals} from "fromKotlin/nkutils";
import CustomerProductsPreviewList from "../../products/CustomerProductsPreviewList";
import {PayNote} from 'types/DocumentsTypes/PayNote';
import {TaxNote} from 'types/DocumentsTypes/TaxNote';
import PreviewDocumentComments from "../PreviewComments";
import {hashIsraelErrorText, hashSign, sendReqForApi} from "../../../../../api/customer/documents.api";
import ExternalSoftwareSendChip from '../ExternalSoftwareSendChip';
import {SNACKBAR_OPEN} from "../../../../../store/actions";
import {
    applySupplierMoneyEdit,
    isSupplierTaxDocument,
    SupplierDocumentDate,
    SupplierEntityPicker,
    SupplierHandLines,
    SupplierMoneyInput,
    SupplierTotalsDiscountLabel,
    useSupplierTaxLineSync
} from './supplierTaxEdit';
import Swal from "sweetalert2";
import MyChip from "ui-component/extended/Chip";
import {callbackNetworkResult} from "../../../../../api/customer/files.api";
import {refreshDocs} from "../../../../../hooks/customer/documents.hooks";

interface InvoiceAndReciptPreviewProps extends PayNote, TaxNote {
    onPaymentChange?: (v: PaymentMethod) => void;
    onProductChange?: (v: any) => void;
    onIdChange?: (v: any) => void;
    pool?: string
    outerDoc?: any
    editting?: boolean;
    setInternalEdit?: (edit: any) => void;
    internalEdit?: any;
}

const InvoiceAndReciptPreview = ({
                                     onPaymentChange,
                                     onProductChange,
                                     editting,
                                     internalEdit,
                                     setInternalEdit,
                                     onIdChange,
                                     pool,
                                     outerDoc,
                                     ...document
                                 }: InvoiceAndReciptPreviewProps) => {

    const theme = useTheme();
    const dispatch = useDispatch();
    const supplierEditable = !!editting && isSupplierTaxDocument(document.type);
    const shownDate = internalEdit?.date ?? document.date;
    const shown = supplierEditable ? {...document, ...(internalEdit || {})} : document;
    useSupplierTaxLineSync({
        enabled: supplierEditable,
        products: document.products,
        handArray: internalEdit?.handArray ?? document.handArray,
        date: shownDate,
        entId: document.entId,
        discount: internalEdit?.discount ?? document.discount,
        deliveryCertificatesIds: document.deliveryCertificatesIds,
        hand: document.hand,
        setInternalEdit
    });
    const [sendSuccess, setSendSuccess] = React.useState<boolean>(false);
    const [hideCostAndGain, setHideCostAndGain] = React.useState(false);
    const refresher = refreshDocs(pool)
    // TODO: Change to single customer fetching
    const entityId = supplierEditable ? (internalEdit?.entId ?? document.entId) : document.entId;
    const customer = isSupplierDocument(document.type)
        ? useSelector((state: RootState) => selectSupplierById(state, entityId))
        : useSelector((state: RootState) => selectCustomerById(state, entityId));
    React.useEffect(() => {
        if (!customer) {
            if (isSupplierDocument(document.type)) {
                dispatch(getSpecificSupplier(Number(entityId)));
                dispatch(getSuppliers());
            } else {
                dispatch(getSpecificCustomer(Number(entityId)));
            }
        }
    }, [dispatch, customer, entityId, document.type]);

    const address = document.details?.street && document.details?.streetNumber ? `${document.details.street}, ${document.details.streetNumber}` : document.details?.street;
    const apiConfig = JSDB().apiConfig
    const startLog = useCallback(async () => {
        if (!document) return
        // if(true) return
        try {
            const x = await hashSign(document.id, document.type === 'invoice' ? 0 : document.type === 'refund' ? 2 : 1)
            if (!x) {
                // token err
                const newWindow = window.open('https://openapi.taxes.gov.il/shaam/production/longtimetoken/oauth2/authorize?response_type=code&client_id=35828e73b8b9edbc05c4ac943f5634f0&scope=invoices_scope&redirect_uri=https://solvitcompany.com/reports/tax-israel', '_blank', 'noopener,noreferrer');
                if (newWindow) newWindow.opener = null;
                return
            }
            if (x.doc) {
                if (setInternalEdit) {
                    setInternalEdit({...internalEdit, taxConfirmation: (x.doc.taxConfirmation)})
                }
                dispatch({
                    type: SNACKBAR_OPEN,
                    open: true,
                    message: 'טוקן החשבונית עודכן בהצלחה!',
                    variant: 'alert',
                    alertSeverity: 'success'
                });
            } else {
                Swal.fire({
                    title: 'לא הצליח לממשק מס הקצאה לחשבונית',
                    target: '#custom-target',
                    text: hashIsraelErrorText(x.text),
                    icon: 'error',
                    showCancelButton: false,
                    confirmButtonColor: '#d63030'
                });
            }
        } catch (e) {
            console.log(e)
            Swal.fire({
                title: 'לא הצליח לממשק מס הקצאה לחשבונית',
                target: '#custom-target',
                text: hashIsraelErrorText(e),
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#d63030'
            });
        }

    }, [document])
    const notes2 = JSDB().getUser().first?.getJsonDesc('notes2')?.name ?? 'הערות 2';
    const notes3 = JSDB().getUser().first?.getJsonDesc('notes3')?.name ?? 'הערות 3';
    const notes4 = JSDB().getUser().first?.getJsonDesc('notes4')?.name ?? 'הערות 4';
    const notes5 = JSDB().getUser().first?.getJsonDesc('notes5')?.name ?? 'הערות 5';
    if (!customer) return null;
    const byProducts = (document.products?.length ?? 0) > 0 || !!onProductChange;
    const gainProducts = document.products ?? [];
    const gain = byProducts
        ? roundDecimals(gainProducts.reduce((sum, x) => sum + (x.costPrice ? x.costPrice : 0) * (x.quantity + (x.quantitySecond ?? 0) * (x.conversion_ratio ?? 0)), 0))
        : 0;
    const totalBeforeTax = roundDecimals(document.mainValue - ((document.taxValue) ? document.taxValue : 0));
    const profit = roundDecimals(totalBeforeTax - gain);
    const profitPercent = totalBeforeTax > 0 ? roundDecimals((profit / totalBeforeTax) * 100) : 0;
    const showCostAndGain = byProducts && !hideCostAndGain;
    return (
        <SubCard
            darkTitle
            title={
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <Grid container sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <Typography fontWeight='bold'>
                            {(document.type === 'invoice') ? 'חשבונית מס' : document.type === 'refund' ? 'חשבונית מס זיכוי' : document.type == 'tax_invoice' ? 'חשבונית מס קבלה' : document.type == 'sup_invoice' ? 'חשבונית ספק' : document.type == 'sup_refund' ? 'זיכוי ספק' : 'חשבונית/קבלה ספק'} {onIdChange ?
                            <NoNegativeInput

                                placeholder={'אוטומטי'}
                                changer={(v) => {
                                    onIdChange(v)
                                }}

                            /> : displayDocumentId(document)}
                        </Typography>
                        {
                            document?.type === "invoice" && (document?.orderId && document?.nkObject?.getConnectedOrder()) ? ( //document?.old_prodcuts?.length > 0 ? (
                                <Chip
                                    label={`הזמנה ${document?.orderId}`}
                                    color={"info"}
                                    sx={{
                                        ml: 2,
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => {

                                    }}
                                />
                            ) : null
                        }
                    </Grid>
                    {(document && document.id != 0 && apiConfig && apiConfig.hasOne()) ?
                        <MyChip color={'primary'}
                                onClick={(c) => callbackNetworkResult(() => sendReqForApi(document.id, document.nkObject.getConnectedDocType()), (result) => {
                                    setSendSuccess(true)
                                    document.one = document?.nkObject?.getOne();
                                    refresher.mutate({
                                        ids: [document.id], types: [document.nkObject.getConnectedDocType()],
                                        full: true,
                                    })
                                })}
                                label={(document.one != undefined && document.one != null && document.one.send || sendSuccess) ? 'נשלח לOne' : 'לא נשלח לOne'}></MyChip> :
                        undefined
                    }
                    {(document && document.id != 0 && apiConfig && apiConfig.hasManager()) ?
                        <MyChip color={'primary'}
                                onClick={(c) => callbackNetworkResult(() => sendReqForApi(document.id, document.nkObject.getConnectedDocType()), (result) => {
                                    setSendSuccess(true)
                                    document.manager = document?.nkObject?.getManager();
                                    refresher.mutate({
                                        ids: [document.id], types: [document.nkObject.getConnectedDocType()],
                                        full: true,
                                    })
                                })}
                                label={(document.manager != undefined && document.manager != null && document.manager.send || sendSuccess) ? 'נשלח למנגר' : 'לא נשלח למנגר'}></MyChip> :
                        undefined
                    }
                    {(document && document.id != 0 && apiConfig && apiConfig.hasStoreNext()) ?
                        <MyChip color={'primary'}
                                onClick={(c) => callbackNetworkResult(() => sendReqForApi(document.id, document.nkObject.getConnectedDocType()), (result) => {
                                    setSendSuccess(true)
                                    document.storeNext = document?.nkObject?.getStoreNext();
                                    refresher.mutate({
                                        ids: [document.id], types: [document.nkObject.getConnectedDocType()],
                                        full: true,
                                    })
                                })}
                                label={(document.storeNext != undefined && document.storeNext != null && document.storeNext.send || sendSuccess) ? 'נשלח לסטורנקס' : 'לא נשלח סטורנקטס'}></MyChip> :
                        undefined
                    }
                    {(document && document.id != 0 && apiConfig && apiConfig.hasHashavshevet()) ?
                        <MyChip color={'primary'}
                                onClick={(c) => callbackNetworkResult(() => sendReqForApi(document.id, document.nkObject.getConnectedDocType()), (result) => {
                                    setSendSuccess(true)


                                    document.hashavshevet = document?.nkObject?.getHashavshevet();
                                    refresher.mutate({
                                        ids: [document.id], types: [document.nkObject.getConnectedDocType()],
                                        full: true,
                                    })
                                })}
                                label={(document.hashavshevet != undefined && document.hashavshevet != null && document.hashavshevet.send || sendSuccess) ? 'נשלח לחשבשבת' : 'לא נשלח לחשבשבת'}></MyChip> :
                        undefined
                    }
                    <ExternalSoftwareSendChip
                        document={document}
                        refresher={refresher}
                    />
                </div>

            }
            secondary={<Logo width={50}/>}
        >
            <Grid container spacing={2}>
                <DocumentHeaderPreview/>

                <Grid item xs={12}>
                    <Grid container>
                        <DocumentClientDetails address={address} name={customer?.name || ""}
                                               businessName={document.details!.companyName}
                                               businessId={document.details!.companyId}
                                               id={customer?.id || ""} external_id={customer?.externalId || ""}
                                               phone={document.details!.phone} email={document.details!.email}/>
                        <Grid item sm={6}>
                            <Grid container>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    {/* <FormattedMessage id={document.type === 'invoice' ? 'Invoice Details' : 'Refund Invoice Details'} /> */}
                                    פרטי חשבונית מס ו/או קבלה
                                </Typography>
                                <Grid item xs={12}>
                                    <Grid container>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                <FormattedMessage id='Date'/>:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <SupplierDocumentDate
                                                editing={supplierEditable}
                                                date={shownDate}
                                                onChange={(date) => setInternalEdit && setInternalEdit({
                                                    ...internalEdit,
                                                    date,
                                                    date_edit: 1
                                                })}
                                            />
                                            {supplierEditable ? (
                                                <Box sx={{mt: 1}}>
                                                    <SupplierEntityPicker
                                                        entId={entityId}
                                                        entName={internalEdit?.entName ?? document.entName}
                                                        onChange={(id, name) => setInternalEdit && setInternalEdit({
                                                            ...internalEdit,
                                                            entId: id,
                                                            entName: name,
                                                            entId_edit: 1
                                                        })}
                                                    />
                                                </Box>
                                            ) : null}
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                תאריך הנפקה:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Typography variant='body2'>
                                                {format(document.issueDate, 'PPPPp', {
                                                    locale: config.i18n === 'he' ? he : enUS
                                                })}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={4}>
                                            <Typography variant='body2'>
                                                <FormattedMessage id='Status'/>:
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                            <Chip
                                                label={<FormattedMessage id={document.status}/>}
                                                variant='outlined'
                                                size='small'
                                                chipcolor={
                                                    document.status === 'pending_approval'
                                                        ? 'warning'
                                                        : document.status === 'approved'
                                                            ? 'success'
                                                            : document.status === 'open'
                                                                ? 'error'
                                                                : ''
                                                }
                                            />
                                        </Grid>
                                        <>
                                            <Grid item xs={4}>
                                                <Typography variant='body2'>
                                                    סוכן:
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={8}>
                                                <Typography variant='body2'>
                                                    {document.agent}
                                                </Typography>
                                            </Grid>
                                        </>
                                        {(!editting) ?
                                            <>
                                                <Grid item xs={4}>
                                                    <Typography variant='body2'>
                                                        מספר הקצאה:
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={8}>
                                                    <Typography variant='body2'>
                                                        {document.taxConfirmation}
                                                    </Typography>
                                                </Grid>
                                                {(document.type === 'sup_invoice' || document.type === 'sup_tax_invoice' || document.type === 'sup_refund') ? (
                                                    <>
                                                        <Grid item xs={4}>
                                                            <Typography variant='body2'>
                                                                מספר חשבונית ספק:
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xs={8}>
                                                            <Typography variant='body2'>
                                                                {document.supplierInvoiceNumber
                                                                    || (typeof document.nkObject?.supplierInvoiceNumber === 'function'
                                                                        ? document.nkObject.supplierInvoiceNumber()
                                                                        : '')}
                                                            </Typography>
                                                        </Grid>
                                                    </>
                                                ) : null}
                                            </> : undefined
                                        }
                                        {
                                            editting && (
                                                <>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            מספר הקצאה:
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Input
                                                            type='text'
                                                            value={internalEdit?.taxConfirmation ?? document.taxConfirmation}
                                                            onChange={(e) => setInternalEdit && setInternalEdit({
                                                                ...internalEdit,
                                                                taxConfirmation: (e.target.value)
                                                            })}
                                                        />
                                                    </Grid>
                                                    {JSDB().getUser().first.hesh_israel == 1 ? <button onClick={() => {
                                                        startLog()
                                                    }}>
                                                        ממשק מס הכנסה
                                                    </button> : undefined}
                                                    {(document.type === 'sup_invoice' || document.type === 'sup_tax_invoice' || document.type === 'sup_refund') ? (
                                                        <>
                                                            <Grid item xs={4}>
                                                                <Typography variant='body2'>
                                                                    מספר חשבונית ספק:
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                <Input
                                                                    type='text'
                                                                    value={internalEdit?.supplierInvoiceNumber
                                                                        ?? document.supplierInvoiceNumber
                                                                        ?? ''}
                                                                    onChange={(e) => setInternalEdit && setInternalEdit({
                                                                        ...internalEdit,
                                                                        supplierInvoiceNumber: e.target.value
                                                                    })}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                <Typography variant='body2'>תשומות ציוד:</Typography>
                                                            </Grid>
                                                            <Grid item xs={8}>
                                                                <input
                                                                    type='checkbox'
                                                                    checked={!!(internalEdit?.supplierInputEquipment
                                                                        ?? document.supplierInputEquipment
                                                                        ?? document.details?.supplierInputEquipment)}
                                                                    onChange={(e) => setInternalEdit && setInternalEdit({
                                                                        ...internalEdit,
                                                                        supplierInputEquipment: e.target.checked,
                                                                        details_edit: 1
                                                                    })}
                                                                />
                                                            </Grid>
                                                        </>
                                                    ) : null}
                                                </>
                                            )
                                        }
                                        <>
                                            {(editting || outerDoc) && (
                                                <Grid container xs={12} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            {notes2}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Input
                                                            value={internalEdit?.notes2 ?? document?.notes2}
                                                            onChange={(e) => outerDoc ? outerDoc((prev) => ({
                                                                ...prev,
                                                                notes2: e.target.value
                                                            })) : setInternalEdit && setInternalEdit({
                                                                ...internalEdit,
                                                                notes2: e.target.value
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {document?.notes2 && document.notes2.length > 0 && !(editting || outerDoc) && (
                                                <Grid container xs={12} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            {notes2}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Typography variant='body2'>
                                                            {document.notes2}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>
                                        <>
                                            {(editting || outerDoc) && (
                                                <Grid container xs={12} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            {notes3}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Input
                                                            value={internalEdit?.notes3 ?? document?.notes3}
                                                            onChange={(e) => outerDoc ? outerDoc((prev) => ({
                                                                ...prev,
                                                                notes3: e.target.value
                                                            })) : setInternalEdit && setInternalEdit({
                                                                ...internalEdit,
                                                                notes3: e.target.value
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {(editting || outerDoc) && (
                                                <Grid container xs={12} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            {notes4}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Input
                                                            value={internalEdit?.notes4 ?? document?.notes4}
                                                            onChange={(e) => outerDoc ? outerDoc((prev) => ({
                                                                ...prev,
                                                                notes4: e.target.value
                                                            })) : setInternalEdit && setInternalEdit({
                                                                ...internalEdit,
                                                                notes4: e.target.value
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            )}
                                            {(editting || outerDoc) && (
                                                <Grid container xs={12} sx={{
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                }}>
                                                    <Grid item xs={4}>
                                                        <Typography variant='body2'>
                                                            {notes5}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={8}>
                                                        <Input
                                                            value={internalEdit?.notes5 ?? document?.notes5}
                                                            onChange={(e) => outerDoc ? outerDoc((prev) => ({
                                                                ...prev,
                                                                notes5: e.target.value
                                                            })) : setInternalEdit && setInternalEdit({
                                                                ...internalEdit,
                                                                notes5: e.target.value
                                                            })}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>
                                        {document.deliveryCertificatesIds.length > 0 ? (
                                            <Grid item xs={12}>
                                                <Typography variant='body2'>
                                                    <FormattedMessage id="Delivery Certificates ID's"/>:
                                                </Typography>
                                            </Grid>
                                        ) : undefined}
                                        {document.deliveryCertificatesIds.map((d, i) => (
                                            <Grid key={i} item xs={4}>
                                                <Typography variant='subtitle1'>{d}</Typography>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                {supplierEditable ? (
                    <SupplierHandLines
                        rows={internalEdit?.handArray ?? document.handArray ?? []}
                        onChange={(handArray) => setInternalEdit && setInternalEdit({
                            ...internalEdit,
                            handArray,
                            lines_edit: 1
                        })}
                    />
                ) : document.handArray && document.handArray?.[0].value !== 0 && document.handArray?.[0].amount !== 0 ? (
                    <>
                        <TableContainer component={Paper}>
                            <Table aria-label="">
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{fontSize: "0.9rem", fontWeight: "bold", textAlign: "right"}}
                                                   align="right">תיאור ידני</TableCell>
                                        <TableCell style={{fontSize: "0.9rem", fontWeight: "bold", textAlign: "right"}}
                                                   align="right">כמות</TableCell>
                                        <TableCell style={{fontSize: "0.9rem", fontWeight: "bold", textAlign: "right"}}
                                                   align="right">{`מחיר${customer!.includeTax ? '(כולל)' : ''}`}</TableCell>
                                        <TableCell style={{fontSize: "0.9rem", fontWeight: "bold", textAlign: "right"}}
                                                   align="right">{`סהכ${customer!.includeTax ? '(כולל)' : ''}`}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {document.handArray.map((row) => (
                                        <TableRow
                                            key={row.description}
                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                        >
                                            <TableCell style={{textAlign: "right"}}
                                                       align="right">{row.description}</TableCell>
                                            <TableCell style={{textAlign: "right"}}
                                                       align="right">{row.amount}</TableCell>
                                            <TableCell style={{
                                                textAlign: "right",
                                                minWidth: row.value.toString().length * 20 < 121 ? row.value.toString().length * 20 : 115
                                            }} align="right">{row.value}<IconCurrencyShekel size={10}
                                                                                            color='black'/></TableCell>
                                            <TableCell style={{textAlign: "right"}} align="right">{
                                                roundDecimals((row.value * row.amount), 2)
                                            }
                                                <IconCurrencyShekel size={10} color='black'/>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </>
                ) : undefined}
                {document.products.length > 0 || onProductChange ? (
                    <>
                        <Grid item xs={12}>
                            <Typography variant='subtitle1' fontWeight='bold'>
                                מוצרים
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <CustomerProductsPreviewList products={document.products.sort((a, b) => (
                                (a?.notePlacement != undefined || b?.notePlacement != undefined) ? ((a?.notePlacement ?? 0) - (b?.notePlacement ?? 0)) :
                                    (a?.position ?? 2000 - b?.position ?? 2000))
                            )}
                                                         withReturns
                                                         disableHoverableIncrementer={!supplierEditable && document.status === 'approved'}
                                                         onProductChange={supplierEditable ? onProductChange : (!onIdChange ? undefined : onProductChange)}
                                                         date={shownDate}
                                                         displayCost={showCostAndGain}
                                                         sup={isSupplierDocument(document.type)}
                                                         id={customer?.id || ""}/>
                        </Grid>
                    </>
                ) : undefined}
                <Grid item xs={12}>
                    <SubCard
                        sx={{
                            bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
                        }}
                    >

                        <Grid container rowSpacing={0}>
                            <Grid item xs={6}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    סהכ לפני מעמ
                                </Typography>
                            </Grid>
                            <Grid item style={{direction: 'ltr'}} xs={5}>
                                {supplierEditable ? (
                                    <SupplierMoneyInput
                                        value={Number(shown.preValue ?? 0)}
                                        onChange={(raw) => applySupplierMoneyEdit(internalEdit, document, 'pre', raw, setInternalEdit)}
                                    />
                                ) : (
                                    <>
                                        <IconCurrencyShekel size={10} color='black'/>
                                        {roundDecimals(document.preValue ?? 0).toLocaleString()}
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={6}>
                                <SupplierTotalsDiscountLabel
                                    editing={supplierEditable}
                                    discount={Number(shown.discount ?? 0)}
                                    onChange={(raw) => applySupplierMoneyEdit(internalEdit, document, 'discount', raw, setInternalEdit)}
                                />
                            </Grid>
                            <Grid item style={{direction: 'ltr'}} xs={5}>
                                <IconCurrencyShekel size={10} color='black'/>
                                {roundDecimals((shown.mainValue ?? 0) - (shown.taxValue ?? 0) - (shown.preValue ?? 0)).toLocaleString()}

                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    סהכ אחרי
                                </Typography>
                            </Grid>
                            <Grid item style={{direction: 'ltr'}} xs={5}>
                                <IconCurrencyShekel size={10} color='black'/>
                                {roundDecimals((shown.mainValue ?? 0) - (shown.taxValue ?? 0)).toLocaleString()}

                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    {/* eslint-disable-next-line react/no-unescaped-entities */}
                                    מע"מ
                                </Typography>
                            </Grid>
                            <Grid item style={{direction: 'ltr'}} xs={5}>
                                {supplierEditable ? (
                                    <SupplierMoneyInput
                                        value={Number(shown.taxValue ?? 0)}
                                        onChange={(raw) => applySupplierMoneyEdit(internalEdit, document, 'tax', raw, setInternalEdit)}
                                    />
                                ) : (
                                    <>
                                        <IconCurrencyShekel size={10} color='black'/>
                                        {roundDecimals(((document.taxValue) ? document.taxValue : 0)).toLocaleString()}
                                    </>
                                )}
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant='subtitle1' fontWeight='bold'>
                                    <FormattedMessage
                                        id='Total'/>
                                </Typography>
                            </Grid>
                            <Grid item style={{direction: 'ltr'}} xs={5}>
                                {supplierEditable ? (
                                    <SupplierMoneyInput
                                        value={Number(shown.mainValue ?? 0)}
                                        onChange={(raw) => applySupplierMoneyEdit(internalEdit, document, 'total', raw, setInternalEdit)}
                                    />
                                ) : (
                                    <>
                                        <IconCurrencyShekel size={10} color='black'/>
                                        {roundDecimals(document.mainValue).toLocaleString()}
                                    </>
                                )}
                            </Grid>
                            {showCostAndGain && gain > 0 ? <>
                                <Grid item xs={6}>
                                    <Typography variant='subtitle1' fontWeight='bold'>
                                        (רווח לפני מעמ)
                                    </Typography>
                                </Grid>
                                <Grid item style={{direction: 'ltr'}} xs={5}>
                                    <Box sx={{display: 'flex', alignItems: 'baseline', gap: 0.5}}>
                                        <Box sx={{color: profit >= 0 ? '#1b5e20' : '#b71c1c'}}>
                                            (<IconCurrencyShekel size={10} color={profit >= 0 ? '#1b5e20' : '#b71c1c'}/>
                                            {profit.toLocaleString()})
                                        </Box>
                                        <Typography variant='body2' component='span' sx={{color: 'black'}}>
                                            [{profitPercent}%]
                                        </Typography>
                                    </Box>
                                </Grid>
                            </> : undefined}

                            {byProducts ? (
                                <Grid item xs={12} sx={{display: 'flex', justifyContent: 'flex-start', mt: 0.5}}>
                                    <Tooltip title={hideCostAndGain ? 'הצג עלות ורווח' : 'הסתר עלות ורווח'}>
                                        <IconButton
                                            size="small"
                                            onClick={() => setHideCostAndGain((v) => !v)}
                                            aria-label={hideCostAndGain ? 'הצג עלות ורווח' : 'הסתר עלות ורווח'}
                                        >
                                            {hideCostAndGain
                                                ? <IconEyeOff size={18} />
                                                : <IconEye size={18} />}
                                        </IconButton>
                                    </Tooltip>
                                </Grid>
                            ) : undefined}

                        </Grid>
                        <Grid item xs={12}>
                            {(document.comment !== '') ?
                                <Grid item xs={12}>
                                    <Typography variant='subtitle1'>
                                        הערות: {document.comment}
                                    </Typography>
                                </Grid>
                                : undefined}
                        </Grid>
                    </SubCard>
                </Grid>
                <Grid item xs={12}>
                    <Grid container>
                        <Grid item sm={12}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                <FormattedMessage id="Payment Methods"/>
                            </Typography>
                        </Grid>
                        {document.payments.map((p) => (
                            <React.Fragment key={p.id}>
                                <Grid item sm={9}>
                                    {!onPaymentChange ? (
                                        <div style={{
                                            display: 'flex',
                                            flex: 1,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}>

                                            <Typography variant="subtitle1">
                                                {paymentMethods[p.method].name}
                                            </Typography>
                                            <Typography variant="subtitle1" style={{direction: 'ltr'}}>
                                                {p.amount}
                                                <IconCurrencyShekel size={10} color="black"/>
                                            </Typography>
                                        </div>
                                    ) : (
                                        <div style={{
                                            display: 'flex',
                                            flex: 1,
                                            flexDirection: 'row',
                                            justifyContent: 'space-between',
                                        }}>
                                            <TextField
                                                id='outlined-select-currency'
                                                select
                                                label='בחר/י שיטת תשלום'
                                                sx={{width: '50%', mb: 1, mt: 1}}
                                                value={p.method}
                                                onChange={(m) => onPaymentChange({
                                                    ...p,
                                                    method: m.target.value as PaymentMethod
                                                })}
                                            >
                                                {Object.keys(paymentMethods).map((p) => (
                                                    <MenuItem key={p} value={p}>
                                                        {paymentMethods[p].name}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                            <HoverableIncrementer

                                                value={p.amount}
                                                disabled={false}
                                                cantChange={!onIdChange}
                                                onIncrement={() => {
                                                    onPaymentChange({
                                                        ...p,
                                                        amount: p.amount + 1
                                                    });
                                                }}
                                                onDecrement={() => {
                                                    onPaymentChange({
                                                        ...p,
                                                        amount: Math.max(0, p.amount - 1)
                                                    });
                                                }}
                                                onChange={(v) => {
                                                    onPaymentChange({...p, amount: Math.max(0, Number(v))});
                                                }}
                                            />
                                        </div>

                                    )}

                                </Grid>
                                {p.check && p.method === 'check' && (

                                    <>
                                        <Grid item sm={4}>
                                            {!onPaymentChange ? (
                                                <Typography variant="subtitle2">
                                                    <FormattedMessage id="Account"/>: {p.check.account}
                                                </Typography>
                                            ) : (
                                                <div>
                                                    <Typography variant="subtitle2">
                                                        <FormattedMessage id="Account"/>:
                                                    </Typography>
                                                    <HoverableIncrementer
                                                        value={p.check.account}
                                                        disabled={false}
                                                        onIncrement={() => {
                                                            {
                                                                ((p.check && p.check.account) || p.check?.account === 0) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {...p.check, account: +(p.check.account) + 1}
                                                                });
                                                            }
                                                        }}
                                                        onDecrement={() => {
                                                            {
                                                                (p.check && p.check.account) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {
                                                                        ...p.check,
                                                                        account: Math.max(0, +(p.check.account) - 1)
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                        onChange={(v) => {
                                                            onPaymentChange({...p, check: {...p.check, account: (v)}});
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item sm={3}>
                                            {!onPaymentChange ? (
                                                <div>
                                                    <Typography variant="subtitle2">
                                                        <FormattedMessage id="Branch"/>: {p.check.branch}
                                                    </Typography>
                                                </div>
                                            ) : (
                                                <div>
                                                    <Typography variant="subtitle2">
                                                        <FormattedMessage id="Branch"/>:
                                                    </Typography>
                                                    <HoverableIncrementer
                                                        value={p.check.branch}
                                                        disabled={false}

                                                        onIncrement={() => {
                                                            {
                                                                ((p.check && p.check.branch) || p.check?.branch === 0) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {...p.check, branch: +(p.check.branch + 1)}
                                                                });
                                                            }
                                                        }}
                                                        onDecrement={() => {
                                                            {
                                                                (p.check && p.check.branch) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {
                                                                        ...p.check,
                                                                        branch: Math.max(0, +(p.check?.branch) - 1)
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                        onChange={(v) => {
                                                            onPaymentChange({...p, check: {...p.check, branch: (v)}});
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item sm={3}>
                                            <Grid item sm={3}>
                                                {onPaymentChange ? (
                                                    <div>
                                                        <Typography variant="subtitle2">
                                                            <FormattedMessage id="Bank"/>
                                                        </Typography>
                                                        <BankAutocomplete
                                                            value={p.check?.bank}
                                                            size='small'
                                                            label=''
                                                            sx={{
                                                                "& .MuiOutlinedInput-root": {
                                                                    borderRadius: "50",
                                                                    border: "transparent",
                                                                    background: "transparent",
                                                                    padding: 1,
                                                                    width: 180
                                                                },
                                                                "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                                                                    border: "transparent",
                                                                }
                                                            }}
                                                            onChange={(bank) => onPaymentChange({
                                                                ...p,
                                                                check: {...p.check, bank}
                                                            })}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div style={{width: '95px'}}>
                                                        <Typography variant="subtitle2">
                                                            <FormattedMessage id="Bank"/>: {p.check.bank}
                                                        </Typography>

                                                    </div>
                                                )}
                                            </Grid>
                                        </Grid>
                                        <Grid item sm={2}/>
                                        <Grid item sm={4}>

                                            {!onPaymentChange ? (
                                                <Typography variant="subtitle2">
                                                    <FormattedMessage id="Check No."/>: {p.check.id}
                                                </Typography>
                                            ) : (
                                                <div>
                                                    <Typography variant="subtitle2">
                                                        <FormattedMessage id="Check No."/>
                                                    </Typography>
                                                    <HoverableIncrementer
                                                        value={p.check.id}
                                                        disabled={false}

                                                        onIncrement={() => {
                                                            {
                                                                ((p.check && p.check.id) || p.check?.id === 0) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {...p.check, id: +(p.check.id) + 1}
                                                                });
                                                            }
                                                        }}
                                                        onDecrement={() => {
                                                            {
                                                                (p.check && p.check.id) &&
                                                                onPaymentChange({
                                                                    ...p,
                                                                    check: {
                                                                        ...p.check,
                                                                        id: Math.max(0, +(p.check?.id) - 1)
                                                                    }
                                                                });
                                                            }
                                                        }}
                                                        onChange={(v) => {
                                                            onPaymentChange({...p, check: {...p.check, id: (v)}});
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item sm={7}>
                                            {!onPaymentChange ? (
                                                <Typography variant="subtitle2">
                                                    <FormattedMessage id="Due Date"/>:{' '}
                                                    {format(
                                                        p.check?.dueDate
                                                            ? typeof p.check.dueDate === 'object'
                                                                ? p.check.dueDate
                                                                : parseJSON(p.check.dueDate)
                                                            : document.date,
                                                        'PP',
                                                        {
                                                            locale: config.i18n === 'he' ? he : enUS
                                                        }
                                                    )}
                                                </Typography>

                                            ) : (
                                                <div style={{margin: 6}}>
                                                    <LocalizationProvider sx={{mt: 3}} dateAdapter={AdapterDateFns}
                                                                          locale={config.i18n === 'he' ? he : enUS}>
                                                        <DatePicker
                                                            mask=''
                                                            renderInput={(props) => <TextField {...props} />}
                                                            label={<FormattedMessage id='Due Date'/>}
                                                            value={p.check?.dueDate}
                                                            onChange={(newValue) => {
                                                                if (newValue) onPaymentChange({
                                                                    ...p,
                                                                    check: {...p.check, dueDate: newValue}
                                                                });
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                            )}
                                        </Grid>
                                        <Grid item sm={1}/>
                                    </>
                                )}
                            </React.Fragment>
                        ))}
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <SubCard
                        sx={{
                            bgcolor: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
                        }}
                    >
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <FormattedMessage id="Total"/>:
                            </Grid>
                            <Grid item xs={6} style={{direction: 'ltr'}}>
                                <Typography variant="subtitle1" fontWeight="bold">
                                    {roundDecimals(document?.payments.reduce((acc, p) => acc + p.amount, 0), 4).toLocaleString()}
                                    <IconCurrencyShekel size={10} color="black"/>
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Grid item xs={12}>
                                <PreviewDocumentComments outerDoc={outerDoc} comment={document.comment} doc={document}
                                                         pool={pool}/>
                            </Grid>
                        </Grid>

                    </SubCard>
                </Grid>
            </Grid>
        </SubCard>
    )
}

export default InvoiceAndReciptPreview;
